define('LNRS/Components/Charts/chartStylebox',["jquery", "matchHeight", "scrollMagic"], function ($, matchHeight, ScrollMagic) {

    function ChartStylebox(scope, color, colors, id) {
        var idSelector = "#" + id,
            controller = new ScrollMagic.Controller();

        // count elements in timeline
        if ( $('.stat-call-out.timeline').length ) {
            $.each($('.stat-call-out.timeline'),
                function() {
                    var tCount = $(this).find('.custom-box').length;
                    $(this).addClass('items-' + tCount);
                });
        }

        function timeline(cDiv){
            if( $(cDiv).length ) {
                $(cDiv + " .score-highlight").matchHeight();
                // make style-boxes the same height
                //var height = $(cDiv + " .score-highlight").css('height');
                //$(cDiv + " .inner").css('height',height);
                $(cDiv + " .score-highlight").each( function() {
                    $(this).parent().css('height', $(this).outerHeight());
                })
            
                $(cDiv + " .custom-box").css('opacity', '0');
                
                new ScrollMagic.Scene({ triggerElement: idSelector, duration: 200 })
                    .on('start', function () {
                        
                        $.each($(cDiv + " .custom-box"), function(i, item){
                            $(cDiv + " .custom-box").delay(1500).css('opacity', '1');  
                            setTimeout(function () {
                                $(item).find('.score-highlight').addClass('show-text');
                            }, 500*(i));
                        });
                        this.enabled(false);
                    }).addTo(controller);
            }    
        }       

        //LNRSSUP-874 timeline not working in score tabs
        if ($(idSelector).length && $(idSelector).parents().hasClass('score-tab-panel')) {
            if ($(idSelector).parents().hasClass('active')) {
                timeline(idSelector);
            }
        }
        else {
            timeline(idSelector);
        }


        $(".score-tab").on("shown.bs.tab", function (ev) {
            timeline(idSelector);
        });

        // for formulas and timeline components
        // JS must grab background-color of component and apply it to child outer element
        if ($(idSelector + '.stat-call-out.formula').length || $(idSelector + '.stat-call-out.timeline').length ) {
            $.each($(idSelector + '.stat-call-out.formula, ' + idSelector + '.stat-call-out.timeline').parent(),
                function(i, infoObj) {
                    var formulaBgColor = $(this).css('background-color');
                    $(this).find('.outer').css("background-color", formulaBgColor);
                });
        }
        
        $.each($(idSelector + ' .custom-box .caption h2'), 
            function(i, titleObject) {
                $(titleObject).css("color", colors[i % 4]);
        });
    }
    
    return function initChartStylebox(args) {
        return args.IsPageEditorEditing === true
            ? null
            : new ChartStylebox(args.scope, args.color, args.colors, args.id);
    };
});
